import { useNavigate } from 'react-router-dom';
import { Card, Chip } from '../ui';

export type BriefStatus = 'generating' | 'active' | 'pressing' | 'complete';

interface BriefCardProps {
  id: string;
  genre: string;
  premiseExcerpt: string;
  status: BriefStatus;
}

const STATUS_LABELS: Record<BriefStatus, string> = {
  generating: 'Generating',
  active: 'Active',
  pressing: 'Pressing',
  complete: 'Complete',
};

export function BriefCard({ id, genre, premiseExcerpt, status }: BriefCardProps) {
  const navigate = useNavigate();

  return (
    <Card
      className="cursor-pointer hover:border-primary/40 transition-colors duration-80"
      onClick={() => navigate(`/brief/${id}`)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          navigate(`/brief/${id}`);
        }
      }}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
          {genre}
        </span>
        <Chip selected={status === 'active' || status === 'complete'} className="text-xs py-0.5 px-2">
          {STATUS_LABELS[status]}
        </Chip>
      </div>
      <p className="text-sm text-foreground leading-relaxed line-clamp-3">
        {premiseExcerpt}
      </p>
    </Card>
  );
}
